export default "__VITE_ASSET__BO5H0hJg__"